import React, { useState } from 'react';
import VideoModal from '../../common/VideoModal';

const HeroSection = () => {
  const [isVideoOpen, setIsVideoOpen] = useState(false);
return (
    <section id="inicio" className="relative min-h-screen flex items-center justify-center overflow-hidden pt-40 md:pt-28 lg:pt-13 xl:pt-0">
      {/* Animated Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-gray-900 via-red-900 to-black">
        <div className="absolute inset-0 opacity-20" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23d51231' fill-opacity='0.1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
        }}></div>
      </div>

      {/* Floating Elements */}
      <div className="absolute inset-0">
        <div className="absolute top-20 left-10 w-72 h-72 bg-red-600 rounded-full mix-blend-multiply filter blur-xl opacity-40 animate-blob"></div>
        <div className="absolute top-40 right-10 w-72 h-72 bg-orange-500 rounded-full mix-blend-multiply filter blur-xl opacity-40 animate-blob animation-delay-2000"></div>
        <div className="absolute bottom-20 left-1/2 w-72 h-72 bg-red-800 rounded-full mix-blend-multiply filter blur-xl opacity-40 animate-blob animation-delay-4000"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 container mx-auto px-6 text-center">
        <div className="inline-block mb-6 px-6 py-2 bg-white/10 backdrop-blur-md rounded-full border border-white/20">
          <span className="text-white/90 text-sm font-medium">🚀 Becas disponibles para cursos 2025</span>
        </div>
        
        <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight animate-fadeInUp">
        Impulsa tu Futuro en
        <span className="block bg-gradient-to-r from-red-500 to-orange-400 bg-clip-text text-transparent pb-3">
          Bogotá con Talento Capital
        </span>
      </h1>

      <p className="text-xl text-white/80 max-w-3xl mx-auto mb-8 animate-fadeInUp animation-delay-200">
        Atenea, la Agencia Distrital para la Educación Superior, la Ciencia y la Tecnología de la Secretaría de Educación de Bogotá, 
        te apoya con becas para cursos cortos. ¡Encuentra la ruta ideal para ti!
      </p>

      <div className="flex flex-col sm:flex-row gap-4 justify-center animate-fadeInUp animation-delay-400">
        <button
            className="group relative px-8 py-4 text-white rounded-full font-semibold overflow-hidden transform hover:scale-105 transition-all"
            style={{
              background: 'linear-gradient(to right, #d51231, #a00e27)'
            }}
          >
            <span className="relative z-10">Descubre las Oportunidades</span>
            <div className="absolute inset-0 bg-gradient-to-r from-red-800 to-red-900 transform scale-x-0 group-hover:scale-x-100 transition-transform origin-left"></div>
          </button>

          <button
            onClick={() => setIsVideoOpen(true)}
            className="px-8 py-4 bg-white/10 backdrop-blur-md text-white rounded-full font-semibold border border-white/20 hover:bg-white/20 transition-all"
          >
            Ver Video Informativo
          </button>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-20 pb-20 lg:pb-0">
          <div className="bg-white/10 backdrop-blur-md rounded-2xl p-6 border border-white/20 transform hover:scale-105 transition-all">
            <h3 className="text-4xl font-bold text-white mb-2">10,000+</h3>
            <p className="text-white/80">Estudiantes Beneficiados</p>
          </div>
          <div className="bg-white/10 backdrop-blur-md rounded-2xl p-6 border border-white/20 transform hover:scale-105 transition-all">
            <h3 className="text-4xl font-bold text-white mb-2">50+</h3>
            <p className="text-white/80">Cursos Disponibles</p>
          </div>
          <div className="bg-white/10 backdrop-blur-md rounded-2xl p-6 border border-white/20 transform hover:scale-105 transition-all">
            <h3 className="text-4xl font-bold text-white mb-2">100%</h3>
            <p className="text-white/80">Becas Completas</p>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-10 left-1/2 transform -translate-x-1/2 animate-bounce">
        <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
        </svg>
      </div>

      {/* Video Modal */}
      <VideoModal isOpen={isVideoOpen} onClose={() => setIsVideoOpen(false)} />
    </section>
  );
};

export default HeroSection;
